import React from 'react';

export default function LandingPage({ onSignInClick }) {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-6"
      style={{ background: 'var(--bg-canvas)' }}
    >
      {/* Wordmark */}
      <div className="mb-12 flex items-center gap-2.5">
        <div className="flex items-center gap-[3px]" style={{ height: 24 }}>
          {(['animate-wave-breathe-1','animate-wave-breathe-2','animate-wave-breathe-3','animate-wave-breathe-4','animate-wave-breathe-5']).map((cls, i) => (
            <div
              key={i}
              className={`rounded-full ${cls}`}
              style={{
                width: 3.5,
                height: `${[0.5,0.75,1,0.75,0.5][i] * 24}px`,
                background: 'var(--accent)',
                opacity: 0.85,
                transformOrigin: 'center',
              }}
            />
          ))}
        </div>
        <span
          className="font-display font-semibold"
          style={{ fontSize: 30, color: 'var(--text-primary)', letterSpacing: '-0.02em' }}
        >
          Larynx
        </span>
      </div>

      {/* Actions */}
      <div className="flex flex-col items-center gap-3 w-full max-w-xs">
        <button
          onClick={onSignInClick}
          className="btn-bouncy w-full text-sm font-bold py-3"
        >
          Sign In
        </button>
        <button
          onClick={onSignInClick}
          className="w-full text-sm font-semibold py-3 rounded-pill transition-all"
          style={{
            background: 'transparent',
            border: '1px solid var(--border-accent)',
            color: 'var(--text-secondary)',
          }}
          onMouseEnter={e => {
            e.currentTarget.style.borderColor = 'var(--accent)';
            e.currentTarget.style.color = 'var(--text-primary)';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.borderColor = 'var(--border-accent)';
            e.currentTarget.style.color = 'var(--text-secondary)';
          }}
        >
          Request Access
        </button>
      </div>
    </div>
  );
}
